import React, { useState } from "react";
import PulseLoader from "react-spinners/PulseLoader";

import { ContentBlock } from "../blocks";

import { useSitemap } from "../providers/content";

const SitmeapChildItems = ({ children }) => {
  return (children && children.length) > 0 ? (
    <ul className="pl-4">
      {children.map((child) => {
        return (
          <li>
            <a dangerouslySetInnerHTML={{ __html: child.title }} href={child.href} className="text-dark" />
            <SitmeapChildItems children={child.children} />
          </li>
        );
      })}
    </ul>
  ) : null;
};

const Sitemap = () => {
  const sitemap = useSitemap();

  return (
    <>
      <ContentBlock>
        <h1 className="title">Sitemap</h1>
        <div className="d-flex justify-content-center">
          <PulseLoader loading={!sitemap} />
        </div>
        {sitemap &&
          sitemap.map((page, index) => (
            <div className="d-inline-block p-2 w-100">
              <div className="border p-3">
                <a href={page.href}>
                  <strong dangerouslySetInnerHTML={{ __html: page.title }} />
                </a>
                <SitmeapChildItems children={page.children} />
              </div>
            </div>
          ))}
      </ContentBlock>
    </>
  );
};

export default Sitemap;
